import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    sortable: false,
    pinnable: false,
    type: 'companyName',
    field: 'companyName',
    headerName: 'Company Name',
    show: true,
    width: 417,
    align: 'start',
    valuesExport: [
      'companyName',
      'customerId',
      'status',
      'companySize',
      'country',
      'website',
      'customerType'
    ]
  },

  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'appName',
    headerName: 'Application Name',
    show: true,
    width: 212,
    align: 'start',
    valuesExport: ['appName']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'appId',
    headerName: 'Application ID',
    show: true,
    width: 162,
    align: 'start',
    valuesExport: ['appId']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'protocol',
    headerName: 'Type',
    show: true,
    width: 92,
    align: 'start',
    valuesExport: ['protocol']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'host',
    headerName: 'Host',
    show: true,
    width: 282,
    align: 'start',
    valuesExport: ['groups']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'endpoint',
    headerName: 'End Point',
    show: true,
    width: 282,
    align: 'start',
    valuesExport: ['endpoint']
  },

  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'networkName',
    headerName: 'Network Name',
    show: true,
    width: 212,
    align: 'start',
    valuesExport: ['networkName']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'networkId',
    headerName: 'Network ID',
    show: true,
    width: 152,
    align: 'start',
    valuesExport: ['networkId']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'fqdn',
    headerName: 'FQDN',
    show: true,
    width: 182,
    align: 'start',
    valuesExport: ['fqdn']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'policyName',
    headerName: 'Policy',
    show: true,
    width: 232,
    align: 'start',
    valuesExport: ['policyName']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'port',
    headerName: 'Port',
    show: true,
    width: 92,
    align: 'start',
    valuesExport: ['port']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'dateCreated',
    field: 'createdAt',
    headerName: 'Created Time',
    show: true,
    width: 152,
    align: 'start',
    valuesExport: ['createdAt']
  },
  {
    sortable: true,
    checkboxProps: { disabled: false },
    selected: true,
    type: 'textGroup',
    field: 'enabled',
    headerName: 'Enabled',
    show: true,
    width: 112,
    align: 'start',
    valuesExport: ['enabled']
  }
];

export const tableConfig = [
  {
    sortable: false,
    pinnable: false,
    type: 'companyName',
    field: 'companyName',
    headerName: 'Company Name',
    show: true,
    width: 417,
    align: 'start',
    fieldsToExport: [
      'companyName',
      'customerId',
      'status',
      'companySize',
      'country',
      'website',
      'customerType'
    ]
  },

  {
    sortable: true,
    type: 'textGroup',
    field: 'appName',
    headerName: 'Application Name',
    show: true,
    width: 212,
    align: 'start',
    fieldsToExport: ['appName']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'appId',
    headerName: 'Application ID',
    show: true,
    width: 162,
    align: 'start',
    fieldsToExport: ['appId']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'protocol',
    headerName: 'Type',
    show: true,
    width: 92,
    align: 'start',
    fieldsToExport: ['protocol']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'host',
    headerName: 'Host',
    show: true,
    width: 282,
    align: 'start',
    fieldsToExport: ['groups']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'endpoint',
    headerName: 'End Point',
    show: true,
    width: 282,
    align: 'start',
    fieldsToExport: ['endpoint']
  },

  {
    sortable: true,
    type: 'textGroup',
    field: 'networkName',
    headerName: 'Network Name',
    show: true,
    width: 212,
    align: 'start',
    fieldsToExport: ['networkName']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'networkId',
    headerName: 'Network ID',
    show: true,
    width: 152,
    align: 'start',
    fieldsToExport: ['networkId']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'fqdn',
    headerName: 'FQDN',
    show: true,
    width: 182,
    align: 'start',
    fieldsToExport: ['fqdn']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'policyName',
    headerName: 'Policy',
    show: true,
    width: 232,
    align: 'start',
    fieldsToExport: ['policyName']
  },

  {
    sortable: true,
    type: 'textGroup',
    field: 'port',
    headerName: 'Port',
    show: true,
    width: 92,
    align: 'start',
    fieldsToExport: ['port']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'createdAt',
    headerName: 'Created Time',
    show: true,
    width: 152,
    align: 'start',
    fieldsToExport: ['createdAt']
  },
  {
    sortable: true,
    type: 'textGroup',
    field: 'enabled',
    headerName: 'Enabled',
    show: true,
    width: 112,
    align: 'start',
    fieldsToExport: ['enabled']
  }
];

export const exportConfig = {
  exportUrl: '/rd/applications/export',
  exportName: 'rd_applications_',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  protocol: [],
  port: [],
  createdAt: { startDate: null, endDate: null },
  statenabledus: [],
  enabled: '',
  companySize: [],
  plan: [],
  billingCycle: [],
  accountManager: [],
  customerSuccessEngineer: []
};

export const defaultNavigation = {
  fieldName: 'createdAt',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
